export const buildTabs = (items, user) =>
  items
    .filter((item) => handlePermissions({ tab: item, user }))
    .map((item) => {
      if (item.navChildren) {
        const filteredChildren = buildTabs(item.navChildren, user);
        return {
          ...item,
          navChildren: filteredChildren,
        };
      }
      return item;
    });

export const defaultProductsTabsMapped = ({ products, defaultProductsTab }) => {
  const navChildren = defaultProductsTab.navChildren.map((nc) => {
    const productRes = products.find((products) => products.id === nc.product);
    let ncAxu = nc;
    if (nc?.navChildren?.length) {
      const ncChildren = nc.navChildren.map((ncChild) => {
        const productChildRes = products.find(
          (products) => products.id === ncChild.product,
        );
        return { ...ncChild, id: productChildRes.uri };
      });
      ncAxu = { ...ncAxu, navChildren: ncChildren };
    }
    return { ...ncAxu, id: productRes.uri };
  });
  return { ...defaultProductsTab, navChildren };
};

export const handlePermissions = ({ tab, user }) => {
  if (!tab.permissions?.length) {
    return true;
  }
  const hasPermission = user?.permissionsList?.some((pm) =>
    tab.permissions.includes(pm.permission),
  );
  return hasPermission;
};
